import { Suspense, useState, useEffect } from "react";
import { ErrorBoundary, Loader } from "@/common";
import { RouterProvider } from "react-router-dom";
import useIntercom from "./hooks/useIntercom";
import router from "@/routes";
import { SolanaContextProvider } from "./contexts/SolanaContext";
import MoveToApp from "./pages/move-to-app";
import useModalStore from "./store/modal.store";
import usePublicSettingsStore from "./store/settings.store";
import { ThemeProvider } from "./contexts/themeContext";

const App = () => {
  const { closeModal } = useModalStore();
  console.log("🚀 ~ App testing :", closeModal)
  const { tokenSymbol, fetchPublicSettings } = usePublicSettingsStore();
  useEffect(() => {
    fetchPublicSettings();
  }, []);
  useIntercom({ id: "123", name: "John Doe", email: "user@example.com" });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    closeModal();
  }, [isMobile, closeModal]);

  return (
    isMobile && (!window.location.pathname.includes("blogs")&& !window.location.pathname.includes("features")) ? (
      <MoveToApp />
    ) : (
      <>
        <SolanaContextProvider>
          <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
            <Suspense fallback={<Loader />}>
              <RouterProvider router={router} />
            </Suspense>
          </ThemeProvider>
        </SolanaContextProvider>
      </>
    )
  );
};

export default App;
